<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="imapConfigurations" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="imapConfigurationId" selectionMode="single"
  [(selection)]="imapConfiguration" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">ImapConfigurations</h1>
      <a href="assets/help/gmail-api-setup-guide.html" target="_blank"
        style="float:left; margin: 12px 0 0 16px; font-size: 13px; color: #C8A95E; text-decoration: none;"
        pTooltip="Gmail API Setup Guide" tooltipPosition="bottom">
        <i class="pi pi-question-circle" style="margin-right:4px;"></i>Gmail API Setup Guide
      </a>
      <span>
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; float: right; margin-left: 10px;"
          (click)="managePermissions()">Manage Permissions</button>
        }
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New ImapConfiguration +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New ImapConfiguration +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'imapConfigurationId', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')" style="width:100px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'email', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'protocol', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'host', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'port', 'in')" style="width:100px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastreaduid', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgreadpercall', 'in')" style="width:50px;"></th>
        <th></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'imapConfiguration', 'in')" style="width:100px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'active', 'in')" style="width:50px;"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-imapConfiguration>
    <tr [pSelectableRow]="imapConfiguration">
      <td>{{imapConfiguration.imapConfigurationId}} </td>
      <td>{{imapConfiguration.name}}</td>
      <td>{{imapConfiguration.email}}</td>
      <td>{{imapConfiguration.protocol}}</td>
      <td>{{imapConfiguration.host}}</td>
      <td>{{imapConfiguration.port}}</td>
      <td>{{imapConfiguration.lastreaduid}}</td>
      <td>{{imapConfiguration.msgreadpercall}}</td>
      <td>{{getUserFullName(imapConfiguration?.user)}}</td>
      <td>{{getAccessName(imapConfiguration) }}</td>
      <td>{{imapConfiguration.active}}</td>
      <td>
        @if (imapConfiguration.gmailSyncEnabled) {
          <span style="color:green;"><i class="pi pi-check-circle"></i> On</span>
        } @else {
          <span style="color:#999;">Off</span>
        }
      </td>
      <td>{{imapConfiguration.gmailBulkSyncStatus || '-'}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(imapConfiguration)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
